import { Benefit } from '@models/payroll/benefit.model';

export class CompanyBenefit extends Benefit {}
